import React from 'react';
import {useRunDatoSourceReferencesExtractMutation} from '~/store/rtkQuery';
import {usePinProtectedAction} from '~/features/Auth/usePinProtectedAction';
import {downloadBlob} from '~/modules/utils/download';
import { FileWarningIcon } from 'lucide-react';

export const Extracts = () => {
  const [runDatoSourceReferencesExtract, {isLoading, error}] = useRunDatoSourceReferencesExtractMutation();
  const {executeWithPinProtection} = usePinProtectedAction();

  const handleRunDatoSourceReferencesExtract = async () => {
    try {
      const csvData = await runDatoSourceReferencesExtract().unwrap();
      const filename = `dato-source-references-${new Date().toISOString()}.csv`;
      downloadBlob(csvData, filename, 'text/csv;charset=utf-8;');
    } catch (err) {
      console.error('Failed to run extract:', err);
    }
  };

  const handleRunExtractWithPinProtection = () => {
    executeWithPinProtection('runDatoSourceReferencesExtract', handleRunDatoSourceReferencesExtract);
  };

  const extracts = [
    {
      id: 'datoSourceReferences',
      name: 'Dato Source References',
      description: 'Download CSV of Dato source references',
      action: handleRunExtractWithPinProtection,
    },
  ];

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Data Extracts</h1>
      
      <div className="grid gap-4">
        {extracts.map((extract) => (
          <div key={extract.id} className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title">{extract.name}</h2>
              <p className="text-base-content/70">{extract.description}</p>
              <div className="card-actions justify-end">
                <button
                  className={`btn btn-primary ${isLoading ? 'btn-disabled' : ''}`}
                  onClick={extract.action}
                  disabled={isLoading}
                >
                  {isLoading ? 'Running...' : 'Run Extract'}
                </button>
              </div>
              {error && (
                <div className="alert alert-error mt-4">
                  <FileWarningIcon className="w-4 h-4" />
                  <span>Error running extract: {error?.message || 'Unknown error'}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}; 